<app-modal-base [title]="dialogTitle" [hasSubmit]="true" (onSubmitEvent)="onSubmit()" [submitText]="submitText"
  [isDisabled]="isDisabled" cancelType="CLOSE">
  <ng-container main *ngTemplateOutlet="content"></ng-container>
</app-modal-base>

<ng-template #content>
  <div mat-dialog-content>
    <div *ngIf="status; else noStatus">
      <p><span class="title">Date:</span><span class="content">{{status.date | dateTimeFormat}}</span></p>
      <p><span class="title">Statut:</span><span class="content">{{'enum.OpenDataActionState.'+status.state |
          translate}}</span>
      </p>
      <p *ngIf="status.state!=='IN_PROGRESS'"><span class="title">Durée:</span><span
          class="content">{{status.duration}}s</span></p>
      <div *ngIf="status.state==='ERROR' && status.error"><span class="title">Erreur:</span>
      </div>
      <div *ngIf="status.error" class="detail-content">{{status.error}}</div>
      <div *ngIf="status.details?.length>0"><span class="title">Détails:</span></div>
      <div class="details" *ngFor="let detailTitle of detailsTitles">
        <div class="detail-title">{{detailTitle}}</div>
        <div class="detail-content" *ngFor="let detail of details[detailTitle]">{{detail}}</div>
      </div>
    </div>
  </div>
</ng-template>

<ng-template #noStatus>
  <div class="text-center">{{ 'propertyDataSyncDialog.noStatus' | translate }}</div>
</ng-template>